var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "TableTask" } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", gap: "10px" } },
        [
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", classNames: "action-button" },
              on: { click: _vm.createTask },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("assignment"),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("task.createTask")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("KanbanList", {
        ref: "kanbanList",
        attrs: { tableRecord: _vm.recordId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }